import { useTranslate } from '@tolgee/react';
import ContractsPage, {
  getServerSideProps as fetcher,
  ContractsPageProps,
} from '@amf/shared/pages/ContractsPage';

import Meta from 'components/Meta';
import Layout from 'components/layout/Layout';
import { AppLinks } from 'utils/links';

export default function Page({ navigation, partners, contracts }: ContractsPageProps) {
  const { t } = useTranslate();
  return (
    <div className='ContractsPage'>
      <Layout navigation={navigation} partners={partners}>
        <Meta title={t('contracts.title')} />
        <ContractsPage
          contracts={contracts}
          links={{ player: AppLinks.player, team: AppLinks.team }}
          buttonProps={{ variant: 'dark-outline' }}
          buttonEnabled
        />
      </Layout>
    </div>
  );
}

export const getServerSideProps = fetcher();
